import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { handleCreateStripeProduct, handleGetPricingPlans } from "../axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";

const validationSchema = Yup.object().shape({
  productName: Yup.string().required("Product Name is required"),
  productCurrency: Yup.string().required("Product Currency is required"),
  productAmount: Yup.number()
    .typeError("Product Amount must be a number")
    .required("Product Amount is required")
    .positive("Product Amount must be greater than zero"),
  productInterval: Yup.string().required("Product Interval is required"),
});

const NewStripeProduct = () => {
  const navigate = useNavigate();
  // Define validation schema using Yup

  const { data: pricingPlansData } = useQuery(["plans"], () =>
    handleGetPricingPlans()
  );

  console.log(pricingPlansData);

  // Initial form values
  const initialValues = {
    productName: "",
    productCurrency: "",
    productAmount: "",
    productInterval: "month",
  };

  // Handle form submission
  const handleSubmit = async (values) => {
    // Handle form submission logic here

    try {
      const res = await handleCreateStripeProduct(
        values.productName,
        values.productAmount,
        values.productCurrency,
        values.productInterval
      );

      if (res.status === 200) {
        toast.success(res.data.message, {
          position: "top-right",
        });
        navigate("/stripe");
      } else {
        toast.error(res?.data?.error, {
          position: "top-right",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <div>
        <p className="font-semibold antialiased tracking-wide text-[22px]">
          New Stripe Product
        </p>
      </div>

      <div className="flex items-center justify-center py-10">
        <div className="ring-2 ring-gray-200 w-[500px] rounded-[8px] p-5">
          <p className="font-semibold">Create New Product</p>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, touched, errors }) => (
              <Form className="mt-10">
                <div>
                  <p>Product Name</p>
                  <Field
                    type="text"
                    name="productName"
                    className={`outline-none ring-2 w-full mt-2 h-12 rounded-[8px] ring-gray-200 indent-3 ${
                      touched.productName && errors.productName
                        ? "ring-2 ring-red-500"
                        : ""
                    }`}
                    placeholder="Ex: SEO Insights FREE Plan"
                  />
                  <ErrorMessage
                    name="productName"
                    component="div"
                    className="text-red-500 mt-1"
                  />
                </div>
                <div className="mt-3">
                  <p>Product Currency</p>
                  <Field
                    type="text"
                    name="productCurrency"
                    className={`outline-none ring-2 w-full mt-2 h-12 rounded-[8px] ring-gray-200 indent-3 ${
                      touched.productCurrency && errors.productCurrency
                        ? "ring-2 ring-red-500"
                        : ""
                    }`}
                    placeholder="Ex: usd"
                  />
                  <ErrorMessage
                    name="productCurrency"
                    component="div"
                    className="text-red-500 mt-1"
                  />
                </div>
                <div className="mt-3">
                  <p>Product Amount</p>
                  <Field
                    type="text"
                    name="productAmount"
                    className={`outline-none ring-2 w-full mt-2 h-12 rounded-[8px] ring-gray-200 indent-3 ${
                      touched.productAmount && errors.productAmount
                        ? "ring-2 ring-red-500"
                        : ""
                    }`}
                    placeholder="Ex: 2000"
                  />
                  <ErrorMessage
                    name="productAmount"
                    component="div"
                    className="text-red-500 mt-1"
                  />
                  <p className="mt-1 text-slate-400">
                    The amount need to be unit amount Ex:$20 = 20*100 = 2000
                  </p>
                </div>
                <div className="mt-3">
                  <p>Product Interval</p>
                  <Field
                    as="select"
                    name="productInterval"
                    className={`outline-none ring-2 w-full mt-2 h-12 rounded-[8px] ring-gray-200 indent-3 ${
                      touched.productInterval && errors.productInterval
                        ? "ring-2 ring-red-500"
                        : ""
                    }`}
                  >
                    <option value="month">Month</option>
                    <option value="year">Year</option>
                  </Field>
                  <ErrorMessage
                    name="productInterval"
                    component="div"
                    className="text-red-500 mt-1"
                  />
                </div>
                <div className="mt-6">
                  <button
                    type="submit"
                    className="bg-black text-white w-full h-12 rounded-[8px]"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default NewStripeProduct;
